module.exports = __webpack_public_path__ + "img/Event1.e6eed4bd.png";